export const ACTION_POST_CREATE_MINDSET = "ACTION_POST_CREATE_MINDSET";
export const ACTION_PUT_UPDATE_MINDSET = "ACTION_PUT_UPDATE_MINDSET";
export const ACTION_GET_LIST_MINDSETS = "ACTION_GET_LIST_MINDSETS";
export const ACTION_DELETE_MINDSET = "ACTION_DELETE_MINDSET";